var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartbeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7614 5.00112C17.2009 5.02186 17.5752 5.32742 17.6835 5.75385L19.2063 11.75H21C21.5523 11.75 22 12.1977 22 12.75C22 13.3023 21.5523 13.75 21 13.75H18.4286C17.9711 13.75 17.5719 13.4396 17.4593 12.9962L16.5526 9.42591L13.3703 18.3363C13.2344 18.7169 12.8828 18.9782 12.4792 18.9987C12.0757 19.0192 11.6994 18.7948 11.5257 18.4299L8.06224 11.1567L6.43967 13.9961C6.26163 14.3077 5.93029 14.5 5.57143 14.5H3C2.44772 14.5 2 14.0523 2 13.5C2 12.9477 2.44772 12.5 3 12.5H4.99111L7.27461 8.50387C7.4593 8.18067 7.80822 7.9868 8.18021 8.00071C8.5522 8.01461 8.88568 8.23399 9.04572 8.57008L12.2965 15.3967L15.7725 5.66367C15.9205 5.24933 16.3219 4.98038 16.7614 5.00112Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeat);
export default __webpack_public_path__ + "static/media/heartbeat.83e31e81a6f3b94549ce9f41fbcb3acd.svg";
export { ForwardRef as ReactComponent };